const edgelessViewportSelector = '.affine-edgeless-viewport';

export function resolveEdgelessViewport(): HTMLElement | null {
  return document.querySelector<HTMLElement>(edgelessViewportSelector);
}

export async function ensureEdgelessMode(): Promise<void> {
  if (resolveEdgelessViewport()) return;
  document
    .querySelector<HTMLElement>('[data-testid="switch-edgeless-mode-button"]')
    ?.click();
  await new Promise(resolve => setTimeout(resolve, 600));
}

export function resolveEdgelessToolbar(): HTMLElement | null {
  const toolbar = document.querySelector<HTMLElement>(
    'edgeless-toolbar-widget'
  );
  return (
    toolbar?.shadowRoot?.querySelector<HTMLElement>(
      '.edgeless-toolbar-toggle-control'
    ) ??
    toolbar ??
    resolveEdgelessViewport()
  );
}

export function resolveDatabase(): HTMLElement | null {
  return (
    document.querySelector<HTMLElement>('affine-database') ??
    resolveEdgelessViewport()
  );
}

export function resolveDatabaseViewSwitcher(): HTMLElement | null {
  return (
    document.querySelector<HTMLElement>(
      '[data-testid="database-view-switcher"]'
    ) ?? resolveDatabase()
  );
}

export function resolveAiChatPanel(): HTMLElement | null {
  return (
    document.querySelector<HTMLElement>('chat-panel') ??
    document.querySelector<HTMLElement>('[data-testid="ai-island"]')
  );
}

export function resolveAiChatInput(): HTMLElement | null {
  return (
    document.querySelector<HTMLElement>('ai-chat-input') ?? resolveAiChatPanel()
  );
}

export async function ensureAiChatOpen(): Promise<void> {
  if (document.querySelector('chat-panel')) return;
  document.querySelector<HTMLElement>('[data-testid="ai-island"]')?.click();
  await new Promise(resolve => setTimeout(resolve, 320));
}
